'use client'

import type { GlobalOverlaysClientProps } from '@maestro/commerce-blocks/components/global-overlays/global-overlays.types'

import { useSession } from 'next-auth/react'

import { useGlobalOverlaysClient } from '@maestro/commerce-blocks/components/global-overlays/batons/use-global-overlays-client'
import RegisterModal from '@maestro/commerce-blocks/components/register/register-modal'
import VippsRegisterModal from '@maestro/commerce-blocks/components/vipps-register-modal/vipps-register-modal'
import LoyaltyRegisterModal from '@maestro/commerce-blocks/loyalty/components/loyalty-register-form/loyalty-register-modal'
import { theme } from '@maestro/local/theme'

export default function GlobalOverlaysClient(props: GlobalOverlaysClientProps) {
  const { cmsPlaceholders, isLoyaltyEnabled, stores } = props
  const { data: session } = useSession()
  const {
    site: { isContentOnly },
    registerPage,
  } = theme()

  const { consents, isLoading } = useGlobalOverlaysClient()

  if (isLoading) {
    return null
  }

  return (
    <>
      {/* Register Modal */}
      {!isContentOnly &&
        registerPage.isSlidein &&
        (isLoyaltyEnabled ? (
          <LoyaltyRegisterModal
            stores={stores}
            cmsPlaceholders={cmsPlaceholders}
            consents={consents}
          />
        ) : (
          <RegisterModal
            cmsPlaceholders={cmsPlaceholders}
            consents={consents}
          />
        ))}

      {/* Vipps Register Modal */}
      {!isContentOnly && session?.authStatus === 'PENDING_REGISTRATION' && (
        <VippsRegisterModal
          consents={consents}
          cmsPlaceholders={cmsPlaceholders}
        />
      )}
    </>
  )
}
